import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getReporteActividadAsesor2 } from "../../endpoints"
function ButtonGroup({
  selectedButton,
  setSelectedOption,
  pendientesCount,
  sinRespuestaCount,
  enSeguiminetoCount,
  clientesCount,
  contactadosCount,
  setCurrentPage,
  selectedDate,
  activeTab,
  user
}) {

  const [loading, setLoading] = useState(false)
  const [contactosPendientes, setContactosPendientes] = useState(0)
  const [contactosSinRespuesta, setContactosSinRespuesta] = useState(0)
  const [clientes, setClientes] = useState(0)
  const [contactosContactados, setContactosContactados] = useState(0)
  console.log(user.id, "SADASDASDASDASDASDASDASD")
  const obtenerReporte = async (periodo) => {
    setLoading(true)
    let fecha
    let fecha2
    if (periodo === "Dia") {
      fecha = new Date();
      fecha2 = new Date(new Date().setHours(0, 0, 0, 0))
    }
    if (periodo === "Semana") {
      fecha = new Date(); // Comienzo del día actual
      fecha2 = new Date(new Date().setHours(0, 0, 0, 0)); // Clonar la fecha actual

      // Retroceder al inicio de la semana (domingo)
      fecha2.setDate(fecha2.getDate() - fecha2.getDay());
    } else if (periodo === "Mes") {
      fecha = new Date(); // Comienzo del día actual
      fecha2 = new Date(fecha); // Clonar la fecha actual

      // Retroceder al inicio del mes anterior
      fecha2.setMonth(fecha2.getMonth() - 1);
      fecha2.setDate(1);
    } else if (periodo === "Anio") {
      fecha = new Date(); // Comienzo del día actual
      fecha2 = new Date(fecha); // Clonar la fecha actual

      // Retroceder al inicio del año anterior
      fecha2.setFullYear(fecha2.getFullYear() - 1);
      fecha2.setMonth(0); // Enero (mes 0)
      fecha2.setDate(1);
    }

    getReporteActividadAsesor2({
      userId: user.id,
      fecha: fecha,
      fecha2: fecha2
    }).then((res) => {
      if (res.status === 200) {
        
        const total = {
          pendientes: 0,
          contactados: 0,
          sinRespuesta: 0,
          clientes: 0
        };
    
        // Iterar sobre el arreglo de objetos y sumar valores
        res.data.forEach((item) => {
          total.pendientes += parseInt(item.pendientes) ;
          total.contactados += parseInt(item.contactados);
          total.sinRespuesta += parseInt(item.sinRespuesra);
          total.clientes += parseInt(item.clientes);
        });
    
        // Asignar los valores acumulados
        setContactosPendientes(total.pendientes + parseInt(pendientesCount));
        setContactosContactados(total.contactados + parseInt(contactadosCount));
        setContactosSinRespuesta(total.sinRespuesta + parseInt(sinRespuestaCount));
        setClientes(total.clientes + parseInt(clientesCount));
        setLoading(false)
      } else {
        console.log(res.data)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    console.log(activeTab)
    obtenerReporte(activeTab)
  }, [activeTab])


  const options = [
    { id: 1, name: 'Actividad', label: 'Última Actividad', count: 3251 },
    { id: 2, name: 'Pendientes', label: 'Pendientes', count: 3251 },
    { id: 6, name: 'Contatado', label: 'Contactados', count: 15204 },
    { id: 3, name: 'SinRespuesta', label: 'Sin Respuesta', count: 15204 },

    { id: 5, name: 'Cliente', label: 'Clientes', count: 15204 },

  ];
  const changeOption = (id) => {
    setSelectedOption(id)

  }

  return (
    <ButtonContainer>
      {options.map((option) => (
        <ButtonOption
          key={option.id}
          selected={selectedButton === option.id}
          onClick={() => changeOption(option.id)}
        >
          {option.label}
          {" "}
          {
            activeTab === "Dia" ? 
            <>
                {option.name === "Pendientes" ? pendientesCount : null}
                {option.name === "Cliente" ? clientesCount : null}

                {option.name === "Contatado" ? contactadosCount : null}
                {option.name === "SinRespuesta" ? sinRespuestaCount : null}

              </> : null
          }
          {
            loading === false && activeTab !== "Dia"  ?
              <>
                {option.name === "Pendientes" ? contactosPendientes : null}
                {option.name === "Cliente" ? clientes : null}

                {option.name === "Contatado" ? contactosContactados : null}
                {option.name === "SinRespuesta" ? contactosSinRespuesta : null}

              </> : null
          }

        </ButtonOption>
      ))}
    </ButtonContainer>
  );
}

export default ButtonGroup;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ButtonOption = styled.button`
flex-grow: 1;
padding: 8px 3px;
margin:0px 8px;
height: 34px;
width: 155px;
border: 2px solid transparent;
border-radius: 4px;
background-color: transparent;
color: #003049;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 13px;
cursor: pointer;
transition: border-color 0.3s ease;
box-sizing: border-box;
border-color: none;
  &:hover {
    border-color: #092a3f;
  }

  ${({ selected }) =>
    selected &&
    `
    border-color: #092a3f;
  `}
`;
